/**
 * SplitText Animation for Quote
 * Animates quote text line by line on scroll
 */

export function initSplitTextQuote() {
  document.fonts.ready.then(() => {
    const quoteElements = gsap.utils.toArray(".quote");
    
    if (quoteElements.length === 0) {
      return; // Exit early if no quote elements found
    }
    
    quoteElements.forEach((el) => {
      SplitText.create(el, {
        type: "lines",
        linesClass: "split-line",
        mask: "lines",
        aria: "auto",
        autoSplit: true,
        onSplit(self) {
          return gsap.timeline({
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              toggleActions: "play none none none",
              once: true
            }
          }).from(self.lines, {
            yPercent: 100,
            autoAlpha: 0,
            duration: 1,
            ease: "power4.out",
            stagger: 0.1,
            onComplete: () => self.revert()
          });
        }
      });
    });
  });
}
